import React from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import { metric } from '@fiverr-private/perseus';
import { I18n } from '@fiverr-private/fiverr_context';
import { translate } from '@fiverr-private/machine_translation';
import { ErrorToast } from '@fiverr-private/orca';
import Logger from '../../logger';
import { ERROR_CONTEXT, METRIC_COUNT_PATH, TOAST_ERROR_MESSAGE_KEY } from './constants';

export const translateUGC = async({ content, sourceInfo }) => {
    try {
        const translateURL = pathfinder('gig_page_translate_ugc');
        const params = {
            text: content,
            url: translateURL,
            retry: true,
            sourceInfo
        };

        const { translatedBlob } = await translate(params);

        return translatedBlob;
    } catch (e) {
        const logger = Logger.getInstance();

        metric.count(METRIC_COUNT_PATH);
        logger.error(e, { context: ERROR_CONTEXT });

        ErrorToast.raise({
            message: <I18n k={TOAST_ERROR_MESSAGE_KEY}/>
        });
    }
};
